import {$, w} from './constants';
let imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin( $ );
let isFirstLoad = true;
let lastVideoTime = 0;
let wasVideoPlaying = false;
let currentSlideIndex = 0;

//Controles para Audio y Video
export function handleAudio( elem ){
    let audio = $(elem)[0]; // Obtener el elemento de audio nativo
    let isSeeking = false;

    // Reproducir automáticamente el audio y el video al llamar a la función
    if(audio) {
        audio.play();
        $("#playPauseBtn").children('.play').addClass('hidden');
        $("#playPauseBtn").children('.pause').removeClass('hidden');
    }

    // Reproducir o pausar el audio al hacer clic en el botón de reproducción/pausa personalizado
    $("#playPauseBtn").on("click", function() {
        if (audio.paused) {
            audio.play();
            $(this).children('.play').addClass('hidden');
            $(this).children('.pause').removeClass('hidden');
        } else {
            audio.pause();
            $(this).children('.pause').addClass('hidden');
            $(this).children('.play').removeClass('hidden');
        }
    });

    // Mute o unmute el audio al hacer clic en el botón de mute/unmute personalizado
    $("#muteBtn").on("click", function() {
        if (audio.muted) {
            audio.muted = false;
            $(this).children('.audio_off').addClass('hidden');
            $(this).children('.audio_on').removeClass('hidden');
        } else {
            audio.muted = true;
            $(this).children('.audio_on').addClass('hidden');
            $(this).children('.audio_off').removeClass('hidden');
        }
    });

    // Controlar el volumen del audio con el rango de volumen personalizado
    $("#volumeRange").on("input", function() {
        audio.volume = $(this).val();
        if ($(this).val() == 0) {
            $(this).children('.audio_on').addClass('hidden');
            $(this).children('.audio_off').removeClass('hidden');
        } else {
            $(this).children('.audio_off').addClass('hidden');
            $(this).children('.audio_on').removeClass('hidden');
        }
    });

    // Actualizar el rango de volumen cuando el volumen del audio cambia
    audio.onvolumechange = function() {
        $("#volumeRange").val(audio.volume);
        if (audio.volume == 0) {
            $(this).children('.audio_on').addClass('hidden');
            $(this).children('.audio_off').removeClass('hidden');
        } else {
            $(this).children('.audio_off').addClass('hidden');
            $(this).children('.audio_on').removeClass('hidden');
        }
    };

    // Actualizar el botón de reproducción/pausa según el estado del audio al iniciar la reproducción
    audio.onplay = function() {
        $(this).children('.play').addClass('hidden');
        $(this).children('.pause').removeClass('hidden');
    };

    audio.onpause = function() {
        $(this).children('.pause').addClass('hidden');
        $(this).children('.play').removeClass('hidden');
    };

    // Actualizar la barra de progreso según el tiempo transcurrido del audio
    audio.ontimeupdate = function() {
        if (!isSeeking) {
            let percentage = (audio.currentTime / audio.duration) * 100;
            $("#progressBar").css("width", percentage + "%");
            $("#seekBarHandle").css("left", percentage + "%");
        }
    };

    // Manejar el evento de clic en el botón de seekBarHandle
    $("#seekBarHandle").on("mousedown", function(e) {
        isSeeking = true;
        $(document).on("mousemove", function(e) {
            let containerLeft = $("#progressBarContainer").offset().left;
            let mouseX = e.pageX - containerLeft;
            let containerWidth = $("#progressBarContainer").width();
            let percentage = (mouseX / containerWidth) * 100;
            percentage = Math.max(0, Math.min(100, percentage));
            $("#progressBar").css("width", percentage + "%");
            $("#seekBarHandle").css("left", percentage + "%");
        });
    });

    $(document).on("mouseup", function() {
        if (isSeeking) {
            let containerLeft = $("#progressBarContainer").offset().left;
            let mouseX = event.pageX - containerLeft;
            let containerWidth = $("#progressBarContainer").width();
            let percentage = (mouseX / containerWidth) * 100;
            percentage = Math.max(0, Math.min(100, percentage));
            audio.currentTime = (percentage / 100) * audio.duration;
            isSeeking = false;
        }
        $(document).off("mousemove");
    });

    // Reiniciar la barra de progreso y cambiar el botón a "Play" cuando el audio termine
    audio.onended = function() {
        $("#progressBar").css("width", "0%");
        $("#playPauseBtn").children('.pause').addClass('hidden');
        $("#playPauseBtn").children('.play').removeClass('hidden');
    };
}

export function handleAudioArray( elem ){
    let list_videos = $(elem).find('video');
    Array.from(list_videos).forEach((video_block) =>{
        const video = $(video_block).get(0);
        const play = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .playPauseBtn');
		const mute = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-volume > .muteBtn');
        const volume = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-volume > .volumeRange');
        const progress_container = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .progressBarContainer');
        const progress = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .progressBarContainer > .progressBar');
        const handle = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .progressBarContainer > .seekBarHandle');
        let isSeeking = false;

        video.muted = false;
        $(mute).children('.audio_off').addClass('hidden');
        $(mute).children('.audio_on').removeClass('hidden');

        // Reproducir o pausar el audio al hacer clic en el botón de reproducción/pausa personalizado
        $(play).on("click", function() {
            if (video.paused) {
                video.play();
                $(this).children('.play').addClass('hidden');
                $(this).children('.pause').removeClass('hidden');
            } else {
                video.pause();
                $(this).children('.pause').addClass('hidden');
                $(this).children('.play').removeClass('hidden');
            }
        });
        // Mute o unmute el audio al hacer clic en el botón de mute/unmute personalizado
        $(mute).on("click", function() {
            if (video.muted) {
                video.muted = false;
                $(this).children('.audio_off').addClass('hidden');
                $(this).children('.audio_on').removeClass('hidden');
            } else {
                video.muted = true;
                $(this).children('.audio_on').addClass('hidden');
                $(this).children('.audio_off').removeClass('hidden');
            }
        });
        // Controlar el volumen del audio con el rango de volumen personalizado
        $(volume).on("input", function() {
            video.volume = $(this).val();
            if ($(this).val() == 0) {
                $(this).children('.audio_on').addClass('hidden');
                $(this).children('.audio_off').removeClass('hidden');
            } else {
                $(this).children('.audio_off').addClass('hidden');
                $(this).children('.audio_on').removeClass('hidden');
            }
        });
        // Actualizar el rango de volumen cuando el volumen del audio cambia
        video.onvolumechange = function() {
            $(volume).val(volume.volume);
            if (volume.volume == 0) {
                $(this).children('.audio_on').addClass('hidden');
                $(this).children('.audio_off').removeClass('hidden');
            } else {
                $(this).children('.audio_off').addClass('hidden');
                $(this).children('.audio_on').removeClass('hidden');
            }
        };
        // Actualizar el botón de reproducción/pausa según el estado del audio al iniciar la reproducción
        video.onplay = function() {
            $(this).children('.play').addClass('hidden');
            $(this).children('.pause').removeClass('hidden');
        };
        video.onpause = function() {
            $(this).children('.pause').addClass('hidden');
            $(this).children('.play').removeClass('hidden');
        };
        // Actualizar la barra de progreso según el tiempo transcurrido del audio
        video.ontimeupdate = function() {
            if (!isSeeking) {
                let percentage = (video.currentTime / video.duration) * 100;
                $(progress).css("width", percentage + "%");
                $(handle).css("left", percentage + "%");
            }
        };
        // Manejar el evento de clic en el botón de seekBarHandle
        $(handle).on("mousedown", function(e) {
            isSeeking = true;
            $(document).on("mousemove", function(e) {
                let containerLeft = $(progress_container).offset().left;
                let mouseX = e.pageX - containerLeft;
                let containerWidth = $(progress_container).width();
                let percentage = (mouseX / containerWidth) * 100;
                percentage = Math.max(0, Math.min(100, percentage));
                $(progress).css("width", percentage + "%");
                $(handle).css("left", percentage + "%");
            });
        });

        $(document).on("mouseup", function() {
            if (isSeeking) {
                let containerLeft = $(progress_container).offset().left;
                let mouseX = event.pageX - containerLeft;
                let containerWidth = $(progress_container).width();
                let percentage = (mouseX / containerWidth) * 100;
                percentage = Math.max(0, Math.min(100, percentage));
                video.currentTime = (percentage / 100) * video.duration;
                isSeeking = false;
            }
            $(document).off("mousemove");
        });

        // Reiniciar la barra de progreso y cambiar el botón a "Play" cuando el audio termine
        video.onended = function() {
            $(progress).css("width", "0%");
            $(play).children('.pause').addClass('hidden');
            $(play).children('.play').removeClass('hidden');
            lastVideoTime = 0;
        };
    });
}

//Slider para Galería
export function slickSlider(elem, startSlide = 0) {
    $(elem).on('init', function() {
        handleAudioArray(elem);
        if (isFirstLoad) {
            // Reproducir el video del slide inicial solo la primera vez
            let initialSlide = $(elem).find('.slick-slide[data-slick-index="' + startSlide + '"]');
            let video = initialSlide.find('video')[0];
            if (video) {
                const play = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .playPauseBtn');
                video.play();
                video.muted = false; // Asegúrate de que el video no esté silenciado
                $(play).children('.play').addClass('hidden');
                $(play).children('.pause').removeClass('hidden');

                // Guardar el tiempo y estado del video
                lastVideoTime = video.currentTime;
                wasVideoPlaying = !video.paused;
            }
            isFirstLoad = false; // Cambiar el estado después de la primera carga
        }
    });

    setTimeout(() => {
        $(elem).slick({
            infinite: true,
            autoplay: false,
            pauseOnHover: true,
            speed: 400,
            slidesToShow: 1,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
            arrows: true,
            prevArrow: '<div class="arrow-map arrow-map--left"></div>',
            nextArrow: '<div class="arrow-map arrow-map--right"></div>',
            initialSlide: startSlide
        });
    }, 100);

    // Evento que se dispara cuando el slide cambia
    $(elem).on('afterChange', function(event, slick, currentSlide) {
        handleAudioArray(elem);
        currentSlideIndex = currentSlide; // Actualizamos el índice del slide actual
        let slide = $(elem).find('.slick-slide.slick-current');
        if ($(slide).hasClass('arrow-over-video')) {
            $(elem).find('.arrow-map').addClass('on-video');
        } else {
            $(elem).find('.arrow-map').removeClass('on-video');
        }

        // Detener y silenciar todos los videos dentro de los slides
        $(elem).find('.slick-slide').each(function(index, slide) {
            // Pausar todos los videos
            $(elem).find('video').each(function() {
                let video = $(this).find('video')[0];
                const play = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .playPauseBtn');
                $(play).children('.pause').addClass('hidden');
                $(play).children('.play').removeClass('hidden');
                this.pause();
            });

            // Reproducir el video del slide activo
            let activeSlide = $(elem).find('.slick-slide[data-slick-index="' + currentSlide + '"]');
            let video = activeSlide.find('video')[0];
            const play = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .playPauseBtn');
            if (video) {
                video.currentTime = lastVideoTime;
                if (video.paused) {
                    video.play(); // Iniciar reproducción solo si el video está pausado
                }
                video.muted = false; // Asegúrate de que el video no esté silenciado
                $(play).children('.play').addClass('hidden');
                $(play).children('.pause').removeClass('hidden');
            }
        });
    });

    // Evento que se dispara antes de cambiar de slide
    $(elem).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        handleAudioArray(elem);
        let slide = $(elem).find('.slick-slide.slick-current');
        if ($(slide).hasClass('arrow-over-video')) {
            $(elem).find('.arrow-map').addClass('on-video');
        } else {
            $(elem).find('.arrow-map').removeClass('on-video');
        }

        // Guardar el tiempo y estado del video actual
        let currentVideo = $(elem).find('.slick-slide[data-slick-index="' + currentSlide + '"]').find('video')[0];
        if (currentVideo) {
            lastVideoTime = currentVideo.currentTime;
            wasVideoPlaying = !currentVideo.paused;
            currentVideo.pause(); 
        }
    });
}

//Fullscreen
export function handleFullscreen(isFullscreen) {
    let videoTimes = [];
    let videoStates = [];

    $('#pop_gallery').find('video').each(function() {
        videoTimes.push({
            currentTime: this.currentTime,
            index: $(this).closest('.slick-slide').index()
        });
        videoStates.push({
            isPlaying: !this.paused,
            index: $(this).closest('.slick-slide').index()
        });
    });
    $('#pop_gallery').slick('unslick');

    loadGalleryWithLoader($('#pop_gallery'), currentSlideIndex);

    setTimeout( function(){
        $('#pop_gallery').on('init', function() {
            $('#pop_gallery').find('video').each(function(index) {
                let video = this;
                let savedTime = videoTimes.find(item => item.index === index);
                let savedState = videoStates.find(item => item.index === index);
                if (savedTime) {
                    video.currentTime = savedTime.currentTime;
                    if ((index === currentSlideIndex) && isFullscreen) {
                        $(video).attr('src', $(video).data('video'));
                        if (savedState && savedState.isPlaying) {
                            video.play();
                        }
                        const play = $(video).parent().siblings('.customControls').find('.pop-up__info-audio-controls-play > .playPauseBtn');
                        $(play).children('.pause').removeClass('hidden');
                        $(play).children('.play').addClass('hidden');
                    } else {
                        $(video).attr('src', $(video).data('video-ch'));
                    }
                }
            });
        });
    }, 150)
}



// Función para cargar la galería con un loader
export function loadGalleryWithLoader(elem, startSlide = 0) {
    showLoader();

    // Utiliza imagesLoaded para detectar cuándo se cargan todos los recursos multimedia
    $(elem).imagesLoaded({ background: true }).always(function() {
        // Una vez que todos los recursos estén cargados, inicializa la galería
        slickSlider(elem, startSlide);
        // Oculta el loader una vez que la galería esté lista
        hideLoader();
    });
}

//Funciones de switch de url (solo un video)
export function switchToNormalVideo (elem, lastVideoTime, videoPlayer){
    const normalVideoURL = $(elem).data('video');
    videoPlayer.attr('src', `${normalVideoURL}#t=${lastVideoTime}`);
    videoPlayer[0].play();
    $("#playPauseBtn").children('.play').addClass('hidden');
    $("#playPauseBtn").children('.pause').removeClass('hidden');
};

export function switchToChVideo(elem, lastVideoTime, videoPlayer){
    let data_video_ch = $(elem).data('video-ch');
    let data_video_ch_exists = $(elem).data('video-ch-exists');
    let videoURL = data_video_ch_exists ? data_video_ch : data_video;
    videoPlayer.attr('src', `${videoURL}#t=${lastVideoTime}`);
    videoPlayer[0].play();
    $("#playPauseBtn").children('.play').addClass('hidden');
    $("#playPauseBtn").children('.pause').removeClass('hidden');
};

// Función para mostrar el loader
function showLoader() {
    $('#loader_gallery').fadeIn();
}

// Función para ocultar el loader
function hideLoader() {
    $('#loader_gallery').fadeOut();
}

//Loader
export function loadMap( isArchive ){
    $('.main-wrap').imagesLoaded({ background: true })
    .always( function( instance ) {
        $('#loader_map').fadeOut();
        if( isArchive ){
            loadMasonry()
        }
    })
    .done( function( instance ) {
        $('#loader_map').fadeOut();
        if( isArchive ){
            loadMasonry()
        }
    })
    .fail( function() {
        $('#loader_map').fadeOut();
        if( isArchive ){
            loadMasonry()
        }
    });
}

/* R E O R D E N A  G A L E R Í A */
export function loadMasonry(){
    let grid = document.querySelector('.masonry-grid');
    let masonry = new Masonry(grid, {
        itemSelector: '.masonry-grid__item',
        columnWidth: '.masonry-grid__sizer',
        percentPosition: true,
        gutter: 10,
        transitionDuration: '0.2s'
    });
}
/* END R E O R D E N A  G A L E R Í A */